import {
	Button,
	Grid,
	Theme,
	Typography,
	createStyles,
	makeStyles,
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import React, { useState } from "react";
import { CreateWorkerType } from "../CreateWorkerType/CreateWorkerType";
import DeleteWorkerType from "../DeleteWorkerType/DeleteWorkerType";
import { EditWorkerType } from "../EditWorkerType/EditWorkerType";
import { useTableWorkerTypes } from "./customHooks/useTableWorkerTypes";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiDataGrid-row": {
				cursor: "pointer",
			},
			"& .MuiDataGrid-columnHeaderTitle, & .MuiTablePagination-caption": {
				fontWeight: "bold",
				fontSize: "12px",
			},
			"& .MuiDataGrid-columnHeaderTitleContainer": {
				padding: "0",
			},
			// '& .MuiButtonBase-root':{
			//   padding: "8px 0",
			// },
			"& .MuiDataGrid-cell--textLeft": {
				fontSize: "12px",
			},
		},
		relative: {
			position: "relative",
		},
		textfield: {
			margin: theme.spacing(2),
		},
		btnModal: {
			display: "flex",
			justifyContent: "flex-end",
		},
		dataTable: {
			padding: theme.spacing(1, 2),
		},
	}),
);
type Props = {
	isLoading: boolean;
	getWorkerTypesFromAPI: Function;
};

export const TableWorkerTypes = ({
	isLoading,
	getWorkerTypesFromAPI,
}: Props) => {
	const [modalCreateActive, setModalCreateActive] = useState(false);
	const [modalEditDataWorkerType, setModalEditDataWorkerType] = useState(false);
	const [modalDeleteWorkerType, setModalDeleteWorkerType] = useState(false);

	const [workerTypeIdForEdit, setWorkerTypeIdForEdit] = useState<number | null>(
		null,
	);
	const [workerTypeIdForDelete, setWorkerTypeIdForDelete] = useState<
		number | null
	>(null);

	const classes = useStyles();

	const { rows, columns } = useTableWorkerTypes({
		setWorkerTypeIdForEdit,
		setModalEditDataWorkerType,
		setWorkerTypeIdForDelete,
		setModalDeleteWorkerType,
	});

	return (
		<Grid container justifyContent="center">
			<Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
				<Typography
					variant="h5"
					style={{ margin: "20px 0 20px", fontWeight: 600 }}
				>
					Worker Types Management
				</Typography>
			</Grid>
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				className={classes.root}
			>
				<Grid
					item
					md={12}
					xs={12}
					style={{ padding: "0 15px" }}
					className={classes.relative}
				>
					<CreateWorkerType
						show={modalCreateActive}
						onHide={(shouldUpdate: boolean) => {
							setModalCreateActive(false);
							if (shouldUpdate) getWorkerTypesFromAPI().then(() => {});
						}}
					/>
					<EditWorkerType
						show={modalEditDataWorkerType}
						workerTypeIdForEdit={workerTypeIdForEdit}
						onHide={(shouldUpdate: boolean) => {
							setModalEditDataWorkerType(false);
							setWorkerTypeIdForEdit(null);
							if (shouldUpdate) getWorkerTypesFromAPI().then(() => {});
						}}
					/>
					<DeleteWorkerType
						show={modalDeleteWorkerType}
						workerTypeIdForDelete={workerTypeIdForDelete}
						onHide={(shouldUpdate: boolean) => {
							setModalDeleteWorkerType(false);
							if (shouldUpdate) getWorkerTypesFromAPI().then(() => {});
						}}
					/>
					<div style={{ width: "100%", height: "60vh" }}>
						<DataGrid
							className={classes.dataTable}
							density={"compact"}
							loading={isLoading}
							rows={rows}
							columns={columns}
							pageSize={25}
							disableColumnMenu
							disableColumnFilter
							disableColumnSelector
							disableSelectionOnClick
						/>
					</div>
					<Grid container justifyContent="flex-end">
						<Grid item md={2} xs={12} className={classes.btnModal}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => setModalCreateActive(!modalCreateActive)}
								fullWidth
								style={{ margin: "20px 0 20px" }}
							>
								New worker type
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
